export const HOLIDAYS: Date[] = [
	new Date(2026, 0, 1), // 1. Januar 2026 (Neujahr)
	new Date(2026, 3, 3), // 3. April 2026 (Karfreitag)
	new Date(2026, 3, 6), // 6. April 2026 (Ostermontag)
	new Date(2026, 4, 1), // 1. Mai 2026 (Tag der Arbeit)
	new Date(2026, 4, 14), // 14. Mai 2026 (Christi Himmelfahrt)
	new Date(2026, 4, 25), // 25. Mai 2026 (Pfingstmontag)
	new Date(2026, 5, 4), // 4. Juni 2026 (Fronleichnam)
	new Date(2026, 9, 3), // 3. Oktober 2026 (Tag der Deutschen Einheit)
	new Date(2026, 10, 1), // 1. November 2026 (Allerheiligen)
	new Date(2026, 11, 25), // 25. Dezember 2026 (1. Weihnachtstag)
	new Date(2026, 11, 26), // 26. Dezember 2026 (2. Weihnachtstag)
	new Date(2027, 0, 1), // 1. Januar 2027 (Neujahr)
	new Date(2027, 2, 26), // 26. März 2027 (Karfreitag)
	new Date(2027, 2, 29), // 29. März 2027 (Ostermontag)
	new Date(2027, 4, 1), // 1. Mai 2027 (Tag der Arbeit)
	new Date(2027, 4, 6), // 6. Mai 2027 (Christi Himmelfahrt)
	new Date(2027, 4, 17), // 17. Mai 2027 (Pfingstmontag)
	new Date(2027, 4, 27), // 27. Mai 2027 (Fronleichnam)
	new Date(2027, 9, 3), // 3. Oktober 2027 (Tag der Deutschen Einheit)
	new Date(2027, 10, 1), // 1. November 2027 (Allerheiligen)
	new Date(2027, 11, 25), // 25. Dezember 2027 (1. Weihnachtstag)
	new Date(2027, 11, 26), // 26. Dezember 2027 (2. Weihnachtstag)
	new Date(2028, 0, 1), // 1. Januar 2028 (Neujahr)
	new Date(2028, 3, 14), // 14. April 2028 (Karfreitag)
	new Date(2028, 3, 17), // 17. April 2028 (Ostermontag)
	new Date(2028, 4, 1), // 1. Mai 2028 (Tag der Arbeit)
	new Date(2028, 4, 25), // 25. Mai 2028 (Christi Himmelfahrt)
	new Date(2028, 5, 5), // 5. Juni 2028 (Pfingstmontag)
	new Date(2028, 5, 15), // 15. Juni 2028 (Fronleichnam)
	new Date(2028, 9, 3), // 3. Oktober 2028 (Tag der Deutschen Einheit)
	new Date(2028, 10, 1), // 1. November 2028 (Allerheiligen)
	new Date(2028, 11, 25), // 25. Dezember 2028 (1. Weihnachtstag)
	new Date(2028, 11, 26) // 26. Dezember 2028 (2. Weihnachtstag)
];

export const SCHOOL_HOLIDAYS_NRW_2026 = {
	easter: {
		start: new Date(2026, 2, 30), // 30. März 2026
		end: new Date(2026, 3, 12) // 12. April 2026
	},
	pentecoste: {
		start: new Date(2026, 4, 26), // 26. Mai 2026
		end: new Date(2026, 4, 26) // 26. Mai 2026
	},
	summer: {
		start: new Date(2026, 6, 20), // 20. Juli 2026
		end: new Date(2026, 8, 1) // 1. September 2026
	},
	autumn: {
		start: new Date(2026, 9, 17), // 17. Oktober 2026
		end: new Date(2026, 10, 1) // 1. November 2026
	},
	christmas: {
		start: new Date(2026, 11, 23), // 23. Dezember 2026
		end: new Date(2027, 0, 6) // 6. Januar 2027
	}
};

export const SCHOOL_HOLIDAYS_NRW_2027 = {
	easter: {
		start: new Date(2027, 2, 22), // 22. März 2027
		end: new Date(2027, 3, 3) // 3. April 2027
	},
	pentecoste: {
		start: new Date(2027, 4, 18), // 18. Mai 2027
		end: new Date(2027, 4, 18) // 18. Mai 2027
	},
	summer: {
		start: new Date(2027, 6, 19), // 19. Juli 2027
		end: new Date(2027, 7, 31) // 31. August 2027
	},
	autumn: {
		start: new Date(2027, 9, 23), // 23. Oktober 2027
		end: new Date(2027, 10, 6) // 6. November 2027
	},
	christmas: {
		start: new Date(2027, 11, 24), // 24. Dezember 2027
		end: new Date(2028, 0, 8) // 8. Januar 2028
	}
};

export const SCHOOL_HOLIDAYS_NRW_2028 = {
	easter: {
		start: new Date(2028, 3, 10), // 10. April 2028
		end: new Date(2028, 3, 22) // 22. April 2028
	},
	summer: {
		start: new Date(2028, 6, 10), // 10. Juli 2028
		end: new Date(2028, 7, 22) // 22. August 2028
	},
	autumn: {
		start: new Date(2028, 9, 23), // 23. Oktober 2028
		end: new Date(2028, 10, 4) // 4. November 2028
	},
	christmas: {
		start: new Date(2028, 11, 21), // 21. Dezember 2028
		end: new Date(2029, 0, 5) // 5. Januar 2029
	}
};

export const SCHOOL_HOLIDAYS_NRW = [
	SCHOOL_HOLIDAYS_NRW_2026.easter,
	SCHOOL_HOLIDAYS_NRW_2026.pentecoste,
	SCHOOL_HOLIDAYS_NRW_2026.summer,
	SCHOOL_HOLIDAYS_NRW_2026.autumn,
	SCHOOL_HOLIDAYS_NRW_2026.christmas,
	SCHOOL_HOLIDAYS_NRW_2027.easter,
	SCHOOL_HOLIDAYS_NRW_2027.pentecoste,
	SCHOOL_HOLIDAYS_NRW_2027.summer,
	SCHOOL_HOLIDAYS_NRW_2027.autumn,
	SCHOOL_HOLIDAYS_NRW_2027.christmas,
	SCHOOL_HOLIDAYS_NRW_2028.easter,
	SCHOOL_HOLIDAYS_NRW_2028.summer,
	SCHOOL_HOLIDAYS_NRW_2028.autumn,
	SCHOOL_HOLIDAYS_NRW_2028.christmas
];
